;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.dashboard')
    .controller('DashboardMoveModalController', DashboardMoveModalController)

  DashboardMoveModalController.$inject = [
    // Angular
    // Libs
    '$uibModalInstance',
    // Managers
    // Services
    // Const
    // Resolved
    'card', 'dashboards'
  ]

  function DashboardMoveModalController (// Angular
    // Libs
    $uibModalInstance,
    // Managers
    // Services
    // Const
    // Resolved
    card, dashboards) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        card: card,
        dashboards: dashboards.data,
        // Public Methods
        cancel: cancel,
        close: close
      })

      init()
    }

    function init () {
      self.dashboards = _.filter(dashboards.data, function (d) { // Filter dashboards to remove dashboard where card is already in
        return !_.find(d.cards, function (c) {
          return c === card._id
        })
      })
    }

    function close () {
      $uibModalInstance.close(self.dest)
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }
  }
})(window.angular, window._)
